exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 576px) {\n.notification-container {\n    position: fixed !important;\n    left: 0px;\n    right: 0px !important;\n    top: 54px;\n    width: 100% !important;\n    max-width: 100% !important;\n    float: none;\n}\n}\n", ""]);

// exports
